

export default {
  name: 'TheFaq',
  props: {
    isHeading: {
      type: Boolean,
      default: false,
    },

    isSubHeading: {
      type: Boolean,
      default: false,
    },

    faq: {
      type: Array,
      default: () => [],
    },
  },

  jsonld () {
    const faq = this.faq.map(item => ({
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    }))

    return {
      '@context': 'https://schema.org/',
      '@type': 'FAQPage',
      name: 'Frequently Asked Questions about CollectionPage Schema Markup',
      mainEntity: faq,
    }
  },
}
